import { canReprocessOrder } from './ocHelpers'

export const buildReprocessHandler = ({
  tabsOrders,
  summary,
  reprocessPurchaseOrder,
  onReprocessSuccess,
  status
}) => {
  const canReprocess = canReprocessOrder({
    status: status,
    processed_lines_percentage: summary?.cards?.ubiqua?.fill_rate,
    is_ignored: tabsOrders?.is_ignored
  })

  const handleReprocess = async () => {
    if (!canReprocess) return

    const res = await reprocessPurchaseOrder()

    if (res?.success && res.new_order_id) {
      onReprocessSuccess(res.new_order_id)
    }
  }

  return { canReprocess, handleReprocess }
}
